import React from 'react';
import { motion } from 'framer-motion';
import { Gem, Zap, Palette } from 'lucide-react';
const differentiators = [{
  icon: Gem,
  title: 'European Craftsmanship',
  description: 'Hand-assembled in Slovenia with a legacy of precision engineering and attention to detail that defines the European standard.'
}, {
  icon: Zap,
  title: 'Off-Grid Engineering',
  description: 'Advanced electrical systems and insulation designed for four-season comfort, allowing you to venture further and stay longer.'
}, {
  icon: Palette,
  title: 'Premium Interior',
  description: 'Yacht-inspired cabinetry, intelligent layouts, and high-end materials that create a sophisticated living space on wheels.'
}];
export function DifferentiatorsSection() {
  return <section className="py-28 md:py-36 bg-white" data-id="element-52">
      <div className="container mx-auto px-6 md:px-12" data-id="element-53">
        <div className="flex flex-col items-center mb-20" data-id="element-54">
          <div className="w-16 h-px bg-robeta-copper mb-8" data-id="element-55" />
          <span className="text-robeta-copper text-xs font-bold uppercase tracking-wide-editorial mb-4" data-id="element-56">
            The Robeta Standard
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12 lg:gap-24" data-id="element-57">
          {differentiators.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center group" data-id="element-58">
              <div className="mb-8 p-4 rounded-full bg-gray-50 text-robeta-black group-hover:bg-robeta-black group-hover:text-robeta-copper transition-colors duration-500" data-id="element-59">
                <item.icon className="w-8 h-8 stroke-[1.5]" data-id="element-60" />
              </div>
              <h3 className="text-xl font-bold text-robeta-black uppercase tracking-editorial mb-6" data-id="element-61">
                {item.title}
              </h3>
              <p className="text-robeta-black/70 font-light leading-relaxed" data-id="element-62">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}